
import { useAuthStore } from '@/stores/auth.store';
import { useCashierStore } from '@/stores/cashier.store';
import { useWorkspaceTabsStore } from '@/stores/workspaceTabs.store';
import { createPinia } from 'pinia'
import type { App } from 'vue'

export const store = createPinia()

// This plugin must stay SYNCHRONOUS. `registerPlugins` (see
// @core/utils/plugins) calls each plugin without awaiting it, and main.ts mounts
// the app immediately afterwards — an async plugin here would let the first
// render happen before `loadFromStorage()` restores auth state, flashing a
// logged-out UI on every reload.
export default function (app: App) {
  app.use(store)

  const auth = useAuthStore()
  const cashier = useCashierStore()
  const workspaceTabs = useWorkspaceTabsStore()
  auth.loadFromStorage();
  cashier.loadFromStorage();
  // Restores the strip only; background pages mount lazily on first activation.
  workspaceTabs.loadFromStorage();
}
